"use client"

import { useEffect, useState } from "react"
import { Analytics } from "@vercel/analytics/next"

export function ConditionalAnalytics() {
  const [hasConsent, setHasConsent] = useState(false)
  const [isChecked, setIsChecked] = useState(false)

  useEffect(() => {
    // Check consent from localStorage
    try {
      const consent = localStorage.getItem("cookie-consent")
      if (consent) {
        const parsed = JSON.parse(consent)
        setHasConsent(parsed.analytics === true)
      }
    } catch {
      setHasConsent(false)
    }
    setIsChecked(true)
  }, [])

  // Don't render until we've checked consent
  if (!isChecked) {
    return null
  }

  // Only render Analytics if user has consented
  if (!hasConsent) {
    return null
  }

  return <Analytics />
}
